// Local change-event emitter used by the web `WebSqliteDatabase` (whose writes
// bypass upstream expo-sqlite's native event emitter). Mirrors the shape of
// expo-sqlite's `addDatabaseChangeListener`.

export interface ManualDatabaseChangeEvent {
  databaseFilePath: string;
  databaseName: string;
  rowId: number;
  tableName: string;
}

type Listener = (event: ManualDatabaseChangeEvent) => void;

const listeners = new Set<Listener>();

export function addManualDatabaseChangeListener(listener: Listener): { remove(): void } {
  listeners.add(listener);
  return {
    remove() {
      listeners.delete(listener);
    },
  };
}

export function emitManualDatabaseChange(event: ManualDatabaseChangeEvent): void {
  for (const listener of listeners) {
    try {
      listener(event);
    } catch {
      // Listeners must not break the write path; swallow to match upstream
      // expo-sqlite's fire-and-forget semantics.
    }
  }
}
